import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <footer class="bg-enduro-black text-gray-400 py-8 mt-auto">
      <div class="container mx-auto px-4 text-center">
          <img src="assets/logo.png" alt="Tour Enduro Logo" class="h-12 w-auto mx-auto mb-4 opacity-90 hover:opacity-100 transition-opacity">
        <p class="text-sm mb-4">
          © {{ currentYear }} Tour Enduro Marghine Experience. All rights reserved.
        </p>
        <div class="flex justify-center gap-4 text-sm">
          <a href="#" class="hover:text-enduro-orange">Privacy Policy</a>
          <a href="#" class="hover:text-enduro-orange">Cookie Policy</a>
        </div>
      </div>
    </footer>
  `
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
